import React from 'react';
import { Schema } from '../../toolympus/hooks/useSchema';
import { NewItemProps } from '../../toolympus/api/useNewItem';
import { FormGrid, SimpleDialog } from '../../toolympus/components/primitives';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { CopDecision } from './useCopDecisionsList';

interface Props extends NewItemProps<Partial<CopDecision>, CopDecision> {
  schema: Schema;
}

export const CreateCopDecisionDialog = (props: Props) => {
  const { isEditing, cancel, errors, item, update, save, schema } = props;
  return (
    <SimpleDialog
      isOpen={isEditing}
      close={cancel}
      submitOnModEnter
      dialogTitle="New decision"
      save={() => save()}>
      {item && <FormGrid columns="1fr">
        <FormControlsForFields
          fields={[
            ["decision", { controlProps: { autoFocus: true }}],
            ["title"],
            ["decision_date"],
          ]}
          data={item}
          onChange={(o,c) => update(c)}
          errors={errors}
          schema={schema}
          />
      </FormGrid>}
    </SimpleDialog>
  );
}

